export function getQueryString(name) {
    // H5: 同时支持 search 与 hash（uni-app 常用 hash 路由：/#/pages/main?adminId=xxx）
    const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    const search = (window.location.search || '').replace(/^\?/, '');
    let r = search.match(reg);
    if (r != null) return decodeURIComponent(r[2]);

    const hash = (window.location.hash || '').replace(/^#/, '');
    const idx = hash.indexOf('?');
    if (idx >= 0) {
        const hashQuery = hash.substring(idx + 1);
        r = hashQuery.match(reg);
        if (r != null) return decodeURIComponent(r[2]);
    }
    return null;
}


// WEBPACK FOOTER //
// ./src/utils/common.js